<template>
  <v-container fluid>
    <v-layout row wrap class="ma-0 pa-0">
      <v-flex xs12 sm6>
        <v-btn
          depressed
          :outline="channelFilter != 'all'"
          :color="channelFilter == 'all' ? 'primary' : 'grey'"
          @click="onChangeChannel('all')"
          class="ma-0 mr-1 mb-1"
          >{{ $t('All') }}</v-btn
        >
        <v-btn
          depressed
          :outline="channelFilter != 'facebook'"
          :color="channelFilter == 'facebook' ? 'primary' : 'grey'"
          @click="onChangeChannel('facebook')"
          class="ma-0 mr-1 mb-1"
        >
          <em class="fab fa-facebook-square mr-1" />
          {{ $t('Facebook') }}
        </v-btn>
        <v-btn
          depressed
          :outline="channelFilter != 'line'"
          :color="channelFilter == 'line' ? 'primary' : 'grey'"
          @click="onChangeChannel('line')"
          class="ma-0 mr-1 mb-1"
        >
          <em class="fab fa-line mr-1" />
          {{ $t('Line') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <date-filter
      v-model="selectedDate"
      @changeDate="onDateChanged"
      :default-filter="'today'"
    ></date-filter>
    <div class="mt-4" v-if="channelFilter == 'facebook'">
      <v-layout>
        <v-flex xs4>
          <ReplyCommentSearchPost
            v-if="facebookPostList"
            v-model="facebookPostList"
            @selectedPost="onSelectedPost"
            :isAgentPerformance="true"
          ></ReplyCommentSearchPost>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <v-layout wrap class="mt-3 mb-2">
        <v-flex xs7>
          <multiselect
            ref="suggest"
            :data-vv-as="$t('How did you hear about us?')"
            v-validate="'required'"
            name="suggest"
            v-model="view"
            :options="viewoptions"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            style="max-width: 300px"
          ></multiselect>
        </v-flex>
        <v-flex xs5 class="text-xs-right form-control d-flex">
          <input type="text" v-model="search" placeholder="search" name="search" />
          <v-btn @click="exportData" outline color="grey" class="ml-3">
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <v-data-table
        :headers="headers"
        :items="filterAdmin"
        :loading="loading"
        class="elevation-1"
        hide-actions
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.totalticket }}</td>
          <td>{{ props.item.pending }}</td>
          <td>{{ props.item.answered }}</td>
          <td>{{ props.item.closed }}</td>
          <td>{{ props.item.cancelled }}</td>
          <td>{{ props.item.cancelledbycustomer }}</td>
          <td>{{ formatAvg(props.item.firsttime / props.item.totalticket) }}</td>
          <td>{{ formatAvg(props.item.closetime / props.item.totalticket) }}</td>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import api from '@/api'
import axios from 'axios'
import config from '@/config'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter'
import ReplyCommentSearchPost from './ReplyCommentSearchPost'
import Multiselect from 'vue-multiselect'
import collect from 'collect.js'
import XLSX from 'xlsx'

export default {
  components: {
    DateFilter,
    ReplyCommentSearchPost,
    Multiselect
  },
  data() {
    return {
      currentView: 'dashboard',
      loading: false,
      headers: [
        { text: 'Name', sortable: false },
        { text: 'All', sortable: false },
        { text: 'Pending', sortable: false },
        { text: 'Answer', sortable: false },
        { text: 'Close', sortable: false },
        { text: 'Cancelled', sortable: false },
        { text: 'Cancelled by customer', sortable: false },
        { text: 'Average 1st response time', sortable: false },
        { text: 'Average resolved ticket time', sortable: false }
      ],
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      showModalPost: false,
      facebookPostList: [],
      channelFilter: 'all',
      selectedPostId: null,
      search: '',
      view: 'Agents',
      viewoptions: ['Agents', 'Group', 'Sub Group', 'All'],
      agents: [],
      responseAgent: []
    }
  },
  mounted() {
    this.getFacebookPost()
    this.getAgentPerformanceByPost()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      loadingAgent: 'getLoadingAgent'
    }),
    filterAdmin: function () {
      let vm = this

      if (vm.agents.length) {
        if (vm.view == 'Customer') {
          return vm.agents
        } else if (vm.view == 'Group') {
          const grouped = collect(vm.responseAgent).groupBy('admingroupid')

          let obj = []
          for (const [key, value] of Object.entries(JSON.parse(grouped.toJson()))) {
            let name = vm.agentGroup.find((el) => {
              return el.id == key
            })
            obj.push({
              ...vm.calculateTicket(value).reduce((total, item) => {
                total['totalticket'] = total['totalticket'] || 0
                total['totalticket'] += item.totalticket
                total['averageclosetime'] = parseFloat(total['averageclosetime']) || 0
                total['averageclosetime'] += parseFloat(item.averageclosetime)
                total['cancelled'] = total['cancelled'] || 0
                total['cancelled'] += item.cancelled
                total['answered'] = total['answered'] || 0
                total['answered'] += item.answered
                total['cancelledbycustomer'] = total['cancelledbycustomer'] || 0
                total['cancelledbycustomer'] += item.cancelledbycustomer
                total['closed'] = total['closed'] || 0
                total['closed'] += item.closed
                total['pending'] = total['pending'] || 0
                total['pending'] += item.pending
                total['firsttime'] = total['firsttime'] || 0
                total['firsttime'] += item.firsttime
                total['closetime'] = total['closetime'] || 0
                total['closetime'] += item.closetime
                return total
              }),
              name: name ? name.groupname : null
            })
          }

          let result = []
          if (vm.search !== '') {
            result = obj.filter((el) => {
              return el.name.includes(vm.search)
            })
          } else {
            result = obj
          }
          return result
        } else if (vm.view == 'Sub Group') {
          const grouped = collect(vm.responseAgent).groupBy('adminsubgroupid')
          let obj = []
          if (vm.agentSubGroup && vm.agentSubGroup.length) {
            for (const [key, value] of Object.entries(JSON.parse(grouped.toJson()))) {
              let name = vm.agentSubGroup.find((el) => {
                return el.id == key
              })
              obj.push({
                ...vm.calculateTicket(value).reduce((total, item) => {
                  total['totalticket'] = total['totalticket'] || 0
                  total['totalticket'] += item.totalticket
                  total['averageclosetime'] = parseFloat(total['averageclosetime']) || 0
                  total['averageclosetime'] += parseFloat(item.averageclosetime)
                  total['cancelled'] = total['cancelled'] || 0
                  total['cancelled'] += item.cancelled
                  total['answered'] = total['answered'] || 0
                  total['answered'] += item.answered
                  total['cancelledbycustomer'] = total['cancelledbycustomer'] || 0
                  total['cancelledbycustomer'] += item.cancelledbycustomer
                  total['closed'] = total['closed'] || 0
                  total['closed'] += item.closed
                  total['pending'] = total['pending'] || 0
                  total['pending'] += item.pending
                  total['firsttime'] = total['firsttime'] || 0
                  total['firsttime'] += item.firsttime
                  total['closetime'] = total['closetime'] || 0
                  total['closetime'] += item.closetime
                  return total
                }),
                name: name ? name.subgroupname : null
              })
            }

            let result = []
            if (vm.search !== '') {
              result = obj.filter((el) => {
                return el.name.includes(vm.search)
              })
            } else {
              result = obj
            }
            return result
          } else {
            return []
          }
        } else if (vm.view == 'All') {
          let obj = []
          obj.push({
            ...vm.calculateTicket(vm.responseAgent).reduce((total, item) => {
              total['totalticket'] = total['totalticket'] || 0
              total['totalticket'] += item.totalticket
              total['averageclosetime'] = parseFloat(total['averageclosetime']) || 0
              total['averageclosetime'] += parseFloat(item.averageclosetime)
              total['cancelled'] = total['cancelled'] || 0
              total['cancelled'] += item.cancelled
              total['answered'] = total['answered'] || 0
              total['answered'] += item.answered
              total['answered'] = total['answered'] || 0
              total['answered'] += item.answered
              total['cancelledbycustomer'] = total['cancelledbycustomer'] || 0
              total['cancelledbycustomer'] += item.cancelledbycustomer
              total['closed'] = total['closed'] || 0
              total['closed'] += item.closed
              total['pending'] = total['pending'] || 0
              total['pending'] += item.pending
              total['firsttime'] = total['firsttime'] || 0
              total['firsttime'] += item.firsttime
              total['closetime'] = total['closetime'] || 0
              total['closetime'] += item.closetime
              return total
            }),
            name: 'All'
          })

          let result = []
          if (vm.search !== '') {
            result = obj.filter((el) => {
              return el.name.includes(vm.search)
            })
          } else {
            result = obj
          }
          return result
        } else {
          let result = []
          if (vm.search !== '') {
            result = vm.agents.filter((el) => {
              return el.name.includes(vm.search)
            })
          } else {
            result = vm.agents
          }
          return result
        }
      } else return []
    }
  },
  methods: {
    onDateChanged() {
      this.getAgentPerformanceByPost()
    },
    getFacebookPost() {
      var vm = this
      var token = vm.selectedBot.page_access_token
      var pageid = vm.selectedBot.pageid
      var url = `https://graph.facebook.com/v4.0/${pageid}/posts?access_token=${token}`

      axios.get(url).then((response) => {
        if (response.status == 200) {
          vm.facebookPostList = response.data.data
        }
      })
    },

    async onSelectedPost(id) {
      this.selectedPostId = id
      this.getAgentPerformanceByPost()
    },
    async getAgentPerformanceByPost() {
      var vm = this
      var pageid = vm.selectedBot.pageid
      var startDate = moment(vm.selectedDate.start).format('YYYY-MM-DD')
      var endDate = moment(vm.selectedDate.end).format('YYYY-MM-DD')
      var channel = vm.channelFilter
      var url = `${config.serverUrl}rabbit/cms/getTicketsByAgent?pageid=${pageid}&startTime=${startDate}&endTime=${endDate}&channel=${channel}`

      if (channel == 'facebook' && vm.selectedPostId) {
        url += `&postid=${vm.selectedPostId}`
      }

      vm.loading = true
      axios.defaults.headers.common = {
        AUTHORIZATION: vm.$store.getters.securityToken
      }
      await axios.get(url).then((response) => {
        if (response && response.data.responsecode == 200) {
          var result = []
          result = this.calculateTicket(response.data.data)
          vm.responseAgent = response.data.data
          vm.agents = result
          vm.showModalPost = false
          vm.loading = false
        }
      })
    },
    calculateTicket(data) {
      let list = {}
      let agents = []
      data.map((el) => {
        if (list.hasOwnProperty(el.adminid)) {
          list[el.adminid].transfer += parseInt(el.transferticket)
          list[el.adminid].firsttime += parseInt(el.firsttime)
          list[el.adminid].closetime += parseInt(el.closetime)
          list[el.adminid].cold_case += parseInt(el.cold_case)
          list[el.adminid].totalticket += 1
          list[el.adminid].all += parseInt(el.amount)
          switch (el.status) {
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'closed':
              list[el.adminid].closed += parseInt(el.amount)
              list[el.adminid].averageclosetime = (
                parseFloat(el.closetime) / parseFloat(el.amount)
              ).toFixed(2)
              break
            case 'cancelled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break
            case 'cancelled by customer':
              list[el.adminid].cancelledbycustomer += parseInt(el.amount)
              break

            default:
              break
          }
        } else {
          list[el.adminid] = {
            adminid: el.adminid,
            name: el.name,
            all: parseInt(el.amount),
            pending: 0,
            closed: 0,
            cold_case: 0,
            answered: 0,
            cancelled: 0,
            cancelledbycustomer: 0,
            averageclosetime: 0,
            transfer: 0,
            firsttime: 0,
            closetime: 0,
            totalticket: 0
          }
          list[el.adminid].transfer += parseInt(el.transferticket)
          list[el.adminid].firsttime += parseInt(el.firsttime)
          list[el.adminid].closetime += parseInt(el.closetime)
          list[el.adminid].cold_case += parseInt(el.cold_case)
          list[el.adminid].totalticket += 1

          switch (el.status) {
            case 'pending':
              list[el.adminid].pending += parseInt(el.amount)
              break
            case 'closed':
              list[el.adminid].closed += parseInt(el.amount)
              list[el.adminid].averageclosetime = (
                parseFloat(el.closetime) / parseFloat(el.amount)
              ).toFixed(2)
              break
            case 'answered':
              list[el.adminid].answered += parseInt(el.amount)
              break
            case 'cancelled':
              list[el.adminid].cancelled += parseInt(el.amount)
              break
            case 'cancelled by customer':
              list[el.adminid].cancelledbycustomer += parseInt(el.amount)
              break

            default:
              break
          }
        }
      })

      for (const key in list) {
        if (list.hasOwnProperty(key)) {
          const element = list[key]
          agents.push(element)
        }
      }
      return agents
    },
    onChangeChannel(val) {
      this.channelFilter = val
      this.getAgentPerformanceByPost()
      this.selectedPostId = null
    },
    formatAvg(secs) {
      const formatted = moment.utc(parseInt(secs) * 1000).format('H ชั่วโมง m นาที s วินาที')
      return formatted
    },
    exportData() {
      let filename = 'AgentPerformance'
      let json = []
      json = this.filterAdmin.map((el, k) => {
        return {
          No: k + 1,
          Name: el.name ? el.name : '-',
          'All Ticket': el.totalticket ? el.totalticket : '0',
          'Pending Ticket': el.pending ? el.pending : '0',
          'Answered Ticket': el.answered ? el.answered : '0',
          'Closed Ticket': el.closed ? el.closed : '0',
          'Cancelled Ticket': el.cancelled ? el.cancelled : '0',
          'Cancelled Ticket by customer': el.cancelledbycustomer ? el.cancelledbycustomer : '0',
          'Average 1st response time': this.formatAvg(el.firsttime / el.totalticket),
          'Average resolved ticket time': this.formatAvg(el.closetime / el.totalticket)
        }
      })

      let dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, `${filename}.xlsx`)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/RabbitReplyFBPost/AgentPerformance.vue